<template>
    <div>
        <navbar1></navbar1>
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <a href="mailto:admin@findworka.com" target="blank"><div class="__ourproimg">
                        <p class="__join">Join over 4000+</p>
                        <p class="__ourproduct1">Designers<br>Sign up</p>
                        <p class="__ourproduct2">Continue here <img src="../assets/img/right-arrow-top-white.svg"> </p>
                    </div></a>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <a href="mailto:admin@findworka.com" target="blank"><div class="__ourproimg1">
                        <p class="__join">Manage products</p>
                        <p class="__ourproduct1">Project managers<br>Sign up</p>
                        <p class="__ourproduct2">Continue here <img src="../assets/img/right-arrow-top-white.svg"> </p>
                    </div></a>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <!-- <a href="http://pro.findworka.com" target="blank"><div class="__ourproimg2"> -->
                    <a href="mailto:admin@findworka.com" target="blank"><div class="__ourproimg2">
                        <p class="__join">Join over 6000k devs</p>
                        <p class="__ourproduct1">Developers<br>Sign up</p>
                        <p class="__ourproduct2">Continue here <img src="../assets/img/right-arrow-top-white.svg"> </p>
                    </div></a>
                </div>
            </div>
        </div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Why become our Pro?</p>
                <p class="__wedop1">By becoming a Findworka Pro, you get premium access to the best software design and development projects.</p>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <img src="../assets/img/quality-control.png" class="__hidimg">
                        <p class="__hidep">Premium Projects</p>
                        <p class="__hidep1">We are very choosy about the kind of projects we manage. The typical Findworka project is at the intersection of being mission critical, the need for great tech, an ambitious client and a decent budget.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <img src="../assets/img/best.png" class="__hidimg">
                        <p class="__hidep">Work with Best</p>
                        <p class="__hidep1">We strive to be the best and take our time to sign up the best programming talents in Africa. This means that if you are an a-lister, you'll collaborate with your type everytime we execute together.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <img src="../assets/img/money.png" class="__hidimg">
                        <p class="__hidep">Make Money</p>
                        <p class="__hidep1">Of Course! We offer very competitive rates to our talents. Whether you work on a 2 week project, a 3-month contract or even get signed up for full-time work with our clients, you'll be doing great work for ambitious people and making money.</p>
                    </div>
                    <!-- <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">Start Executing</p>
                        <p class="__hidep1">Focus on building the Nth version of your products by hiring from our network of PRO talents. </p>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="container">
            <p class="__hirep">Not yet a Pro?</p>

            <p class="__hirep1">You shouldn't worry. We understand that to become an expert, you need to<br> keep practicing, learning, sharing and collaborating. That is why we have<br> Findworka Academy and the Saucecode community to help you grow.</p>
        <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="__proimgcard">

                        <p class="__procp">Start your tech career by joining our tech academy</p>
                        <a href="https://jointechcampus.com/" target="_blank" class="btn __procpbtn">Join techcampus</a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="__proimgcard1">
                        <p class="__procp">Join campus alpha<br> or participate in our events</p>

                        <a href="mailto:admin@findworka.com" target="blank" class="btn __procpbtn1">Join Saucecode</a>
                        <!-- <a href="http://saucecode.xyz/hackathon/alpha" target="blank" class="btn __procpbtn1">Join Saucecode</a>
                        <a style="cursor:pointer" target="blank" class="btn __procpbtn1">Join Saucecode</a> -->
                    </div>
                </div>
            </div>
        </div><br><br>
    </div>
</template>

<script>
import navbar1 from '../components/navbar1';


export default {
    components: { navbar1,},
}
</script>

<style scoped>
@import '../assets/css/pro';
</style>


// WEBPACK FOOTER //
// src/components/pro.vue